import { render, staticRenderFns } from "./sidebar.html?vue&type=template&id=70438bd9&"
import script from "./sidebar.js?vue&type=script&lang=js&"
export * from "./sidebar.js?vue&type=script&lang=js&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=70438bd9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports